<template>
  <div class="box11-page">
    <pageTitle
      title="拥抱新机遇  他们已经开始"
      text="深夜你在刷视频的时候，他们已经开始利用短视频变现了"
    />
    <studentEvaluation
      :evaluateData="evaluateData"
      :styleData="styleData"
      @provideIndex="provideIndex"
      scrollColor="#ffccdd"
      blockColor="#ff6699"
      :columNum="columNum"
    />
    <previewImage
      ref="previewImage"
      :clickedIndex="clickedIndex"
      :isPreview="isPreview"
      type="img"
      :targetImg="evaluateData[this.cur].imgUrlList[this.clickedIndex].img"
      @close="close"
    />
    <div class="jiaonang"></div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import previewImage from "../common/previewImage.vue";
import studentEvaluation from "../common/student-evaluation.vue";
export default {
  components: {
    pageTitle,
    studentEvaluation,
    previewImage,
  },

  data() {
    return {
      clickedIndex: 0,
      isPreview: false,
      cur: 0,
      evaluateData: [
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/newMedia2/box11/1.png"),
              id: 1,
            },
            {
              img: require("../../../assets/coursePage/newMedia2/box11/2.png"),
              id: 2,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/newMedia2/box11/3.png"),
              id: 3,
            },
            {
              img: require("../../../assets/coursePage/newMedia2/box11/4.png"),
              id: 4,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/newMedia2/box11/5.png"),
              id: 5,
            },
            {
              img: require("../../../assets/coursePage/newMedia2/box11/6.png"),
              id: 6,
            },
          ],
        },
      ],

      titleColor: "#3E4F48",
      columNum: 3,
      styleData: {
        imgBorder: "border: 0.08rem solid #ffccdd;",
        imgHoverBorder: "border: 0.08rem solid #ff6699;",
        contentBoxWidth: '487px'
      },
    };
  },
  methods: {
    provideIndex(index, index1) {
      this.clickedIndex = index1;
      this.cur = index;
      this.isPreview = true;
    },
    close() {
      this.isPreview = false;
      this.clickedIndex = 0;
      this.cur = 0;
      // this.imageUrl = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.box11-page {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/newMedia2/box11/bgc.png") no-repeat;
  background-size: cover;
  .jiaonang {
    width: 100%;
    height: 140px;
    background: url('../../../assets/coursePage/newMedia2/box11/img.png') no-repeat center;
    background-size: auto 100%;
    margin: 80px auto 0;
    
  }
}
</style>
